import React from 'react';
import { Script } from 'gatsby'

// Permite desactivar la carga de HubSpot en runtime añadiendo un query param a
// la URL: ?nohubspot (solo HubSpot) o ?nothirdparty (HubSpot + GTM, este último
// se bloquea en html.js). Pensado para tests de PageSpeed en producción.
// Se evalúa en cliente (en SSR window no existe, así que el HTML no cambia).
const isHubspotDisabledByQuery = () => {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    return params.has('nohubspot') || params.has('nothirdparty');
};

export const wrapRootElement = ({ element }) => {
    const loadHubspot =
        !!process.env.GATSBY_HUBSPOT_SCRIPT_ID && !isHubspotDisabledByQuery();

    return (
        <>
            {loadHubspot && (
                <Script
                    id="hs-script-loader"
                    src={`https://js-eu1.hs-scripts.com/${process.env.GATSBY_HUBSPOT_SCRIPT_ID}.js`}
                    strategy="idle"
                />
            )}
            {element}
        </>
    )
}
